import { Progress } from '@/components/ui/progress';
import { useGetProgressQuery } from '@/services/api/demandProgressService';

interface Props {
  matterId: string;
  inline?: boolean;
  className?: string;
}

export const WorkspaceDemandProgressBar = ({
  matterId,
  inline = false,
  className = '',
}: Props) => {
  const { data } = useGetProgressQuery(matterId, {
    pollingInterval: 1000,
  });
  // Only hide if no data exists or if both done and total are 0 (no progress at all)
  if (!data || (data.done === 0 && data.total === 0)) return null;
  const pct = (data.done / data.total) * 100;
  return (
    <div
      className={`${inline ? '' : 'fixed bottom-4 right-4'} ${className} w-64 z-30 bg-white shadow-md rounded p-2`}
    >
      <Progress value={pct} />
      <p className="text-center text-xs mt-1">
        Drafting demand… {data.done}/{data.total}
      </p>
    </div>
  );
};

// Deprecated alias – will be removed once all imports are migrated.
export const DemandGenProgress = WorkspaceDemandProgressBar;
